import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  overlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    alignItems: 'center',
    height: 'auto',
    zIndex: 1000000,

    variants: {
      position: {
        top: {
          top: rt.insets.top + theme.spacing[4],
        },
        bottom: {
          bottom: rt.insets.bottom + theme.spacing[4],
        },
      },
    },

    // On web, adjust spacing since there's no safe area
    _web: {
      variants: {
        position: {
          top: {
            top: theme.spacing[6],
          },
          bottom: {
            bottom: theme.spacing[4],
          },
        },
      },
    },
  },

  container: {
    width: '100%',
    gap: theme.spacing[3],
    paddingHorizontal: theme.spacing[4],
  },

  toastContainer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: theme.spacing[13],
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.s,
    gap: theme.spacing[5],
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: theme.borderRadius.xs,
    elevation: 1000000,
    zIndex: 1000000,
    backgroundColor: colors.backgroundL3,

    variants: {
      variant: {
        success: {
          backgroundColor: colors.backgroundPositive,
        },
        error: {
          backgroundColor: colors.backgroundNegative,
        },
        info: {
          backgroundColor: colors.backgroundL3Inverse,
        },
      },
    },

    _web: {
      width: '95%',
      // Caps to the content column so a toast doesn't stretch the full width of
      // a desktop monitor.
      maxWidth: theme.breakpoints.tablet,
      alignSelf: 'center',
    },
  },

  iconCircle: {
    width: theme.spacing[8],
    height: theme.spacing[8],
    borderRadius: theme.borderRadius.full,
    alignItems: 'center',
    justifyContent: 'center',
  },

  iconHalo: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: theme.borderRadius.full,
    opacity: 0.2,
    variants: {
      variant: {
        success: {
          backgroundColor: colors.iconStatic,
        },
        error: {
          backgroundColor: colors.iconStatic,
        },
        info: {
          backgroundColor: colors.iconPrimaryInverse,
        },
      },
    },
  },

  message: {
    variants: {
      variant: {
        success: {
          color: colors.textStatic,
        },
        error: {
          color: colors.textStatic,
        },
        info: {
          color: colors.textPrimaryInverse,
        },
      },
    },
  },
  description: {
    variants: {
      variant: {
        success: {
          color: colors.textStatic,
        },
        error: {
          color: colors.textStatic,
        },
        info: {
          color: colors.textPrimaryInverse,
        },
      },
    },
  },

  webContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 2147483647, // Maximum z-index value
    pointerEvents: 'box-none',
    // On web, use 'fixed' positioning to ensure proper stacking
    _web: {
      position: 'fixed',
    },
  },

  androidContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    // Ensure maximum elevation on Android
    elevation: 2147483647,
    zIndex: 2147483647,
  },
}));
